'use client';

import { useEffect, useRef } from 'react';
import { WooboxBlock } from '~/types/custom';

export function Woobox(props: WooboxBlock) {
  if (!props?.woobox?.wooboxId) return null;

  const wooboxId = props.woobox.wooboxId;
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    // Load Woobox SDK
    const script = document.createElement('script');
    script.id = 'woobox-sdk';
    script.src = '//woobox.com/js/plugins/woo.js';
    document.body.appendChild(script);
  }, []);

  return (
    <div className="woobox" id="offer">
      <div
        className="woobox-offer"
        data-offer={wooboxId}
        style={{ margin: 'auto' }}
      ></div>
    </div>
  );
}
